export default __webpack_public_path__ + "static/media/Circle_Circle_Note_Icon.fd5a94f7.svg";